import { render, staticRenderFns } from "./TourTabs.vue?vue&type=template&id=1ab037c2&"
import script from "./TourTabs.vue?vue&type=script&lang=js&"
export * from "./TourTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports